import axios from 'axios';
import { BUSINESS_URL } from '../../API/Api';

const getAllBusiness = async (token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${BUSINESS_URL}`,
		headers: headers,
	});
	return response.data;
};

const searchBusiness = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'GET',
		baseURL: `${BUSINESS_URL}/search`,
		headers: headers,
		params: data,
	});
	return response.data;
};

const CreateBusiness = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POST',
		baseURL: `${BUSINESS_URL}/create`,
		headers: headers,
		data: data,
	});
	return response.data;
};

const deleteBusiness = async (id, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POSt',
		baseURL: `${BUSINESS_URL}/delete`,
		headers: headers,
		data: id,
	});

	return response.data.data.id;
};
//update Business
const updateBusiness = async (data, token) => {
	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};
	const response = await axios({
		method: 'POST',
		baseURL: `${BUSINESS_URL}/edit`,
		headers: headers,
		data: data,
	});

	return response.data;
};

const BusService = {
	getAllBusiness,
	CreateBusiness,
	deleteBusiness,
	updateBusiness,
	searchBusiness,
};
export default BusService;
